<template>
  <div class="column-headers-container">
    <div
      v-for="column in enabledColumns"
      :key="column.id"
      :class="['column-header', { 'right-align': getColumnAlignment(column) === Align.Right }]"
    >
      <div class="header-text" :data-external="`pricing-table-header-text-name:${column.name}`">
        {{ getColumnAttribute(column, 'displayName') }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import type { PricingTableSection } from '@getaccept/editor-lib';
import { usePricingTableColumns, useEditorMetaDataStore, Align } from '@getaccept/editor-lib';
import { useProductPropertiesStore } from '@getaccept/editor-lib/src/store/product-properties.store';
import { storeToRefs } from 'pinia';
import type { PropType } from 'vue';
import { defineComponent, toRefs } from 'vue';

export default defineComponent({
  name: 'PricingTableColumnHeaders',
  props: {
    section: { type: Object as PropType<PricingTableSection>, default: () => ({}) },
    isPreCalculated: { type: Boolean },
  },
  setup(props) {
    const { context } = storeToRefs(useEditorMetaDataStore());
    const { productProperties } = storeToRefs(useProductPropertiesStore());
    const { section, isPreCalculated } = toRefs(props);
    const { enabledColumns, getColumnAttribute, getColumnAlignment } = usePricingTableColumns(
      section,
      isPreCalculated,
      productProperties,
      context
    );

    return {
      Align,
      enabledColumns,
      getColumnAttribute,
      getColumnAlignment,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/editor-lib/src/scss/pricing-table-column-headers';
</style>
